<template>
  <div class="cart-product cart-product--warning cart-product--notification">
    <div class="cart-product__container">
      <oie-base-image
        :images="cartRow.item.image ? `${getAssetPath(cartRow.item.image)}?preset=ProductSmall&watermark=OIEWatermarkSmall` : `${getAssetPath('/globalassets/missing404/404.png')}?preset=ProductThumb`"
        :alt-text="cartRow.item.name"
        image-width="3.75rem"
        image-height="3.75rem"
        class="cart-product__image"></oie-base-image>

      <div class="cart-product__information-container">
        <div class="cart-product__top">
          <a
            :href="cartRow.item.url"
            class="cart-product__details"
            @click="closeNotification()">
            {{ cartRow.item.name }}

            <div class="cart-product__details-article-number">
              {{ `${tStatic('headerCartItemNumberLabel')} ${cartRow.itemId}` }}
            </div>
          </a>

          <div v-if="(!cartRow.item.isProdBaseItem || cartRow.item.isProdBaseItemViaBC) && cartRow.stock - cartRow.quantity < 0 && !cartRow.item.isOrderItem" class="cart-product__details-exceded-amount">
            {{ tStatic('exceededStockLevelLabel') }}
          </div>

          <button v-if="closeNotificationHandler" class="cart-product__desmiss-action-button" @click="closeNotificationHandler()">
            <oie-use-svg svg="close"></oie-use-svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cartRow: {
      type: Object,
      required: true
    },
    closeNotificationHandler: {
      type: Function,
      default: null
    }
  }
}
</script>

<style lang="scss">
.cart-product--notification {
  border: none;
}

.cart-product--notification .cart-product__top {
  margin-bottom: 0;
  padding-right: measure(full);
}

.cart-product__desmiss-action-button {
  @include reset-button;
  position: absolute;
  top: 50%;
  right: 0;
  width: 1.5rem;
  height: 1.5rem;
  transform: translateY(-50%);

  & > svg {
    width: 100%;
    height: 100%;
    color: color(gray-2);
  }
}
</style>
